import React from 'react';

import Blogs from './Blogs';

function BlogsPage() {
    return ( 
       <>
       <Blogs/>
       </>
     );
}

export default BlogsPage;